import React from 'react';

// 鋪滿容器、置中裁切的圖片，統一 hero / 卡片封面圖的樣式，避免各處重複手刻同一段 inline style
export default function CoverImage({ src, alt, opacity = 1, onErrorHide = false, style }) {
  return (
    <img
      src={src}
      alt={alt}
      loading="lazy"
      style={{ position:'absolute', inset:0, width:'100%', height:'100%', objectFit:'cover', opacity, ...style }}
      onError={onErrorHide ? e => { e.target.style.display = 'none'; } : undefined}
    />
  );
}
